import { Button, MenuItem, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useRecoilStateLoadable } from 'recoil';
import {
  FormikSelect,
  FormikTextField,
} from '../../../common/formik-material-ui';
import dataTableScss from '../../modules/Manage/pages/queues-table/data-table.module.css';

import { GridSortModel, GridValueGetterParams } from '@mui/x-data-grid';
import { useMakePHPRequest } from '../../../common/useMakePHPRequest';
import { user } from '../../../recoil/atoms/user';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import {
  DataTable,
  IColDef,
} from '../../modules/Manage/pages/queues-table/DataTable';
import { countryGroups, countryList } from '../../subpages/countryList';
import { useSnackbarWithStyles } from '../notifications/SnackbarProviderWithStyles';

const useStyles = makeStyles((theme: Theme) => ({
  spaceHorizontally: {},
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
  },
  add: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    marginLeft: theme.spacing(1), // space between fields
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  button: {
    marginLeft: theme.spacing(1), // space between fields
  },
  selectNumberButton: {
    '&:hover': {
      backgroundColor: 'red',
    },
  },
  tab: {
    maxWidth: 'none',
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTab-wrapper': {
      flexDirection: 'row',
    },
    '&[tabindex="0"]': {
      backgroundColor: theme.palette.divider,
    },
  },
  tabs: {},
  tabIcon: {
    marginRight: 15,
  },
  header: {
    color: 'var(--primary)', // pull color from primary
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: 10,
  },
  modal: {
    paddingBottom: 0,
    maxHeight: 'calc(100vh - 210px)',
    overflowY: 'auto',
  },
  defaultAction: {
    marginTop: theme.spacing(2),
  },
  warningIcon: {
    color: 'orange',
  },
  spinner: {
    position: 'fixed !important' as 'fixed',
  },
  selectMenuPaper: {
    maxHeight: 460, //'calc(100% - 96px)'
  },
  outbound: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
    flexGrow: 1,
    width: '100px',
  },
  billing: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
    flexGrow: 1,
    width: '70px',
  },
  editButton: {
    maxWidth: '155px',
    maxHeight: '50px',
    minWidth: '155px',
    minHeight: '50px',
  },
  fieldRow: {
    display: 'flex',
    marginLeft: '2px',
    marginRight: '2px',
  },
}));

export const AddNumberModalTab = ({
  formik,
  // handleNumberSearch,
  numberToBuy,
  setNumberToBuy,
  setRate,
}) => {
  const classes = useStyles();
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  const [hoverText, setHoverText] = useState('Select');
  const sortModel = [{ field: 'number', sort: 'desc' }] as GridSortModel;
  useEffect(() => {
    if (numberToBuy) {
      setHoverText('Selected');
    }
  }, []);
  const [userAtom] = useRecoilStateLoadable(user);
  const makeRequest = useMakePHPRequest({
    userAtom: userAtom.contents,
  });
  const handleNumberSearch = async () => {
    // console.log('FMK: ', formik);
    const { values, setFieldValue } = formik;

    // Add number submit
    const { response } = await makeRequest({
      methodName: methodNameEnum.PHONE_NUMBER_SEARCH,
      payload: {
        cc: values.buyNumber.country,
        pattern: values.buyNumber.areaCode,
        numtype: values.buyNumber.numType.toLocaleLowerCase(),
        sms: values.buyNumber.smsAble,
      },
    });
    // console.log('RES: ', response);
    // console.log(response, 'response of phone number search');
    if (response?.data.success === 'false') {
      enqueueSnackbarWithStyles({
        message: response.data.message,
        alertProps: { severity: 'warning' },
      });
    }
    if (response?.data?.response?.objects?.length >= 1) {
      setFieldValue(
        'buyNumber.availableNumbers',
        response?.data?.response?.objects.map((o) => ({
          ...o,
          id: o.number,
        }))
      );
    }
  };
  function handleSelectNumber(row) {
    if (numberToBuy) {
      setNumberToBuy(0);
      setRate(0);
      setHoverText('Select');
    } else {
      setNumberToBuy(row.number);
      setRate(row.monthly_rental_rate);
      setHoverText('Unselect');
    }
    // handleShowBuy();
    // console.log(row, 'find num id ');
  }
  const handleMouseEnter = (selectedNumber) => {
    if (selectedNumber === numberToBuy) {
      setHoverText('Unselect');
    }
  };
  const handleMouseLeave = (selectedNumber) => {
    if (numberToBuy && selectedNumber === numberToBuy) {
      setHoverText('Selected');
    }
  };

  const smsOptions = [
    {
      code: 'Y',
      name: 'Yes',
    },
    {
      code: 'E',
      name: 'Either',
    },
  ];
  const numTypes = ['Local', 'Tollfree', 'Mobile', 'Any'];
  const columns = [
    {
      field: 'number',
      headerName: 'Number',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
    },
    {
      field: 'region',
      headerName: 'Region',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
    },
    {
      field: 'monthly_rental_rate',
      headerName: 'Price',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      renderCell: priceFormatter,
    },
    {
      field: 'mmsEnabled',
      headerName: 'MMS',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      renderCell: mmsFormatter,
    },
    {
      field: 'smsEnabled',
      headerName: 'SMS',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      renderCell: smsFormatter,
    },
    {
      field: 'type',
      headerName: 'Buy',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      renderCell: buyNumberFormatter,
    },
  ] /*satisfies*/ as IColDef[];
  const customPaginationActions = (props) => {
    return null;
  };
  function priceFormatter(params) {
    return <b>${params.row.monthly_rental_rate}</b>;
  }
  function mmsFormatter(params) {
    if (params.row.mmsEnabled) {
      return <b>Yes</b>;
    } else {
      return <b>No</b>;
    }
  }
  function smsFormatter(params) {
    if (params.row.smsEnabled) {
      return <b>Yes</b>;
    } else {
      return <b>No</b>;
    }
  }
  function buyNumberFormatter(params: GridValueGetterParams) {
    const selectedNumber = numberToBuy && params.row.id !== numberToBuy;
    return (
      <Button
        className={`${classes.button} ${
          numberToBuy && classes.selectNumberButton
        }`}
        onClick={() => handleSelectNumber(params.row)}
        variant="contained"
        color="primary"
        disabled={Boolean(selectedNumber)}
        onMouseEnter={() => handleMouseEnter(params.row.id)}
        onMouseLeave={() => handleMouseLeave(params.row.id)}
      >
        {!selectedNumber && hoverText}
        {/* {!selectedNumber ? hoverText : 'Select'} */}
      </Button>
    );
  }
  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <FormikSelect
            name="buyNumber.country"
            className={clsx(classes.field, classes.spaceHorizontally)}
            formik={formik}
            fullWidth
            label="Country"
            size="small"
            variant="outlined"
            native
          >
            {countryGroups.map((
              group // print out optgroup(s)
            ) => (
              <optgroup key={group} label={group}>
                {countryList
                  .filter((country) => country.groups?.includes(group))
                  .map((country) => (
                    <option key={country.code} value={country.code}>
                      {country.name}
                    </option>
                  ))}
              </optgroup>
            ))}
            {countryList.map((
              country // print out options
            ) => (
              <option key={country.code} value={country.code}>
                {country.name}
              </option>
            ))}
          </FormikSelect>
          <FormikSelect
            name="buyNumber.smsAble"
            className={classes.field}
            formik={formik}
            fullWidth
            label="SMSable"
            size="small"
            variant="outlined"
          >
            {smsOptions.map((sms, index) => (
              <MenuItem key={index} value={sms.code}>
                {sms.name}
              </MenuItem>
            ))}
          </FormikSelect>
          <FormikTextField
            id="standard-basic"
            label="Name"
            name="buyNumber.numberName"
            formik={formik}
            size="small"
            variant="outlined"
            fullWidth
          />
        </div>
        <div className="col-lg-6">
          <FormikTextField
            className={classes.field}
            id="standard-basic"
            label="Area Code"
            name="buyNumber.areaCode"
            formik={formik}
            size="small"
            variant="outlined"
            fullWidth
          />
          <FormikSelect
            // style={{ marginTop: '3px' }}
            className={classes.field}
            id="standard-basic"
            label="Local/Tollfree"
            name="buyNumber.numType"
            formik={formik}
            size="small"
            variant="outlined"
            fullWidth
          >
            {numTypes.map((num, index) => (
              <MenuItem key={index} value={num}>
                {num}
              </MenuItem>
            ))}
          </FormikSelect>
          <div
            style={{
              display: 'flex',
            }}
          >
            <Button
              className={classes.button}
              disableElevation
              variant="contained"
              color="primary"
              // disabled={formik.isSubmitting || !formik.dirty}
              // onClick={formik.handleSubmit}
              onClick={handleNumberSearch}
              style={{
                marginLeft: '0',
                marginTop: '15px',
              }}
            >
              Search
            </Button>
          </div>
        </div>
        {numberToBuy !== 0 && formik.values.addAgent.calleridNumber === '' && (
          <p
            style={{
              color: 'red',
              margin: '1.3rem auto 0',
            }}
          >
            Clicking Add Agent will apply the selected number to the new agent’s
            Outbound Caller ID Number
          </p>
        )}
        {numberToBuy !== 0 && formik.values.addAgent.calleridNumber !== '' && (
          <p
            style={{
              color: 'red',
              margin: '1.3rem auto 0',
              paddingLeft: '12px',
            }}
          >
            Clicking Add Agent will preserve the number previously entered for
            the new agent's Outbound Caller ID Number as well as purchase the
            selected number
          </p>
        )}
      </div>
      <div>
        {formik.values.buyNumber.availableNumbers.length > 1 && (
          <DataTable
            columns={columns}
            rows={formik.values.buyNumber.availableNumbers}
            sortModel={sortModel}
            hideSortIcon={true}
            customPaginationActions={customPaginationActions}
            hideRowsPerPageOptions={true}
          />
        )}
      </div>
    </>
  );
};
